import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=4ed1ca88&scoped=true"
import script from "./MentionList.vue?vue&type=script&lang=ts"
export * from "./MentionList.vue?vue&type=script&lang=ts"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=4ed1ca88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1ca88",
  null
  
)

export default component.exports